import type { fileHorsLigne as Fr } from '../fr/fileHorsLigne';

/** « fileHorsLigne » in English — typed on the French: a missing sentence does not compile. */
export const fileHorsLigne: typeof Fr = {
  reconnectezTitre: (n: number) => `Sign in again to send ${n} ${n === 1 ? 'entry' : 'entries'}`,
  reconnectezTexte: 'Your session expired while the device was offline.',
  rienPerdu: ' Nothing is lost',
  rienPerduSuite: ': the entries and their photos are kept here.',
  refusesTitre: (n: number) => `${n} ${n === 1 ? 'entry' : 'entries'} rejected by the server`,
  refusesTexte: 'They are kept on this device. Read the reason below: nobody will delete them for you.',
  attenteTitre: (n: number) => `${n} ${n === 1 ? 'entry' : 'entries'} waiting to be sent`,
  attenteTexte: 'They are kept on this device and will be sent as soon as the connection is stable.',
  masquer: 'Hide',
  voir: 'View',
  envoi: 'Sending…',
  envoyer: 'Send now',
  colSaisie: 'Entry',
  colCreee: 'Created',
  colEssais: 'Attempts',
  refusee: 'Rejected',
  confirmerAbandon: (libelle: string) => `Permanently discard “${libelle}”? This entry and its photos will be lost.`,
  abandonner: 'Discard',
  sessionExpiree: 'Session expired — sign in again and the entry will be sent afterwards.',
  refusServeur: (code: number) => `Rejected by the server (${code})`,
};
